// 服务器响应状态码
export const CODE_SUCCESS = 0
export const CODE_NO_LOGIN = -10002
export const CODE_NO_PRIVILEGE = -10003
export const CODE_NOT_BINDING = -30001

// 头部认证状态
export const VERIFY_STATUS_NONE = 1  // 法大大未认证
export const VERIFY_STATUS_NONE_OVERSEA = 6 // 未认证
export const VERIFY_STATUS_PENDING = 2 // 待审核
export const VERIFY_STATUS_TRIAL_PASS = 7 // 初审通过
export const VERIFY_STATUS_PASS = 3 // 已认证
export const VERIFY_STATUS_REFUSE = 4 // 法大大审核不通过
export const VERIFY_STATUS_REFUSE_OVERSEA = 8 // 审核不通过

// 大陆公司审核状态
export const MAINLAND_STATUS_LEGAL_PERSON = 1 // 法人信息
export const MAINLAND_STATUS_COMPANY_INFO = 2 // 企业信息
export const MAINLAND_STATUS_PENDING = 3.1 // 审批中
export const MAINLAND_STATUS_APPROVE_PASS = 3.2 // 初审通过
export const MAINLAND_STATUS_APPROVE_REFUSE = 3.3 // 审批不通过
export const MAINLAND_STATUS_PASS = 4 // 通过

//认证类型
export const FADADA_VERTIFY = 1 // 法大大认证
export const XIAOMAN_VERTIFY = 2 // 小满认证
export const ALI_VERTIFY = 3 // 阿里认证

// 订单类型
export const ORDER_TYPE_NEW = 1 // 新增
export const ORDER_TYPE_APPEND = 2 // 追加
export const ORDER_TYPE_RENEW = 3 // 续约
export const ORDER_TYPE_UPGRADE = 4 // 升级
export const ORDER_TYPE_UPGRADE_RENEW = 5 // 升级+续约
export const ORDER_TYPE_CHANGE_RENEW = 6 // 转款续约
export const ORDER_TYPE_PROMOTION_RENEW = 7 // 优惠升级

// 发票类型
export const INVOICE_TYPE_GENERAL = 1 // 普通发票
export const INVOICE_TYPE_SPECIAL = 2 // 增值税发票
export const INVOICE_TYPE_FORMAL = 3 // 形式发票

// 支付类型
export const PAY_TYPE_ALI = 1 // 移动支付（支付宝）
export const PAY_TYPE_UNION = 2 // 银联
export const PAY_TYPE_UNION_DOLLAR = 3 // 银联
export const PAY_TYPE_ALIBABA = 4 // 阿里巴巴

// 订单状态
export const ORDER_STATUS_PEND = 0 // 待支付
export const ORDER_STATUS_COMPLETE = 1 // 完成
export const ORDER_STATUS_FAIL = 2 // 失败
export const ORDER_STATUS_CANCEL = 3 // 取消
export const ORDER_STATUS_PROGRESS = 4 // 部分支付

export const INVOICE_TYPE_NEW_NOT_VERIFY = 4 //未认证的新签订单

// 发票状态
export const INVOICE_STATUS_PEND = 0 // 待审核
export const INVOICE_STATUS_SUCCESS = 1 // 已开票
export const INVOICE_STATUS_POST = 2 // 已寄出
export const INVOICE_STATUS_REFUSE = 3 // 已拒绝

// 产品id
export const PRODUCT_ID_1910 = 8 // 1910 Smart发现版
export const PRODUCT_ID_GOOGLEADS = 17 // Google AdWords
export const PRODUCT_ID_MARKETING = 16 // Marketing
export const PRODUCT_ID_LITE = 18 // Lite

// 产品服务id
export const SERVICE_ID_ACCOUNT = 1 // 追加账号
export const SERVICE_ID_EDM = 2 // 追加EDM
export const SERVICE_ID_SPACE = 3 // 追加空间
export const SERVICE_ID_PAGE = 5 // 追加落地页
export const SERVICE_ID_DISCOVERY = 9 // 追加发现营销模块
export const SERVICE_ID_ERPAPI = 10 // 追加ERP-API模块
export const SERVICE_ID_ERPHELP = 11 // 追加ERP-实施费
export const SERVICE_ID_BILLS = 12 // 追加单据模块
export const SERVICE_ID_PROCESS = 13 // 追加流程管理
export const SERVICE_ID_STAT = 14 // 追加统计管理
export const SERVICE_ID_PROHELP = 16 // 追加Pro实施费
export const SERVICE_ID_GOOGLE_CID = 17 // 谷歌账号
export const SERVICE_ID_ADS_ADVANCE = 18 // 预存广告费
export const SERVICE_ID_ADS_SERVICE = 19 // 广告服务费
export const SERVICE_ID_STATION = 20 // 建站服务费
export const SERVICE_ID_OKKI_API_BASE = 21; // OKKI-API基础服务
export const SERVICE_ID_OMS = 27; // 阿里/非阿里客户 购买OMS
export const SERVICE_ID_SAVE = 28; // 进销存模块
export const SERVICE_ID_MODULE = 29; // 生成模块
export const SERVICE_ID_FINANCE = 30; // 财务模块
export const SERVICE_ID_HUNTER = 31; // okki hunter
export const SERVICE_ID_WABA = 38; // waba售卖

export const SERVICE_ID_SHOP = 39; // Shop营销
export const SERVICE_ID_SHOP_AD_FEE= 40; // Shop广告服务费
/* AI功能包 */
export const SERVICE_ID_K_COIN = 41;
// K币
export const SERVICE_ID_K_COIN_2 = 42;
export const SERVICE_ID_WECHAT_LICENSE = 43;
export const SERVICE_ID_WECHAT_ARCHIVE = 44;
// WhatsApp沟通功能
export const SERVICE_ID_WA_COMMUNICATE_FUNCTION = 45;
// WhatsApp营销功能
export const SERVICE_ID_WA_MARKETING_FUNCTION = 46;

//cid授权状态
export const GRANT_PASS = 2 // 邀请成功

//预约状态
export const NO_APPOINTMENT = "0"; //未预约
export const APPOINTMENT_NOT_IMPLETE = "1"; //已预约未实施
export const IMPLETE_SUCCESS = "2"; //实施完成
export const CANNOT_APPOINTMENT = "3"; //不能预约
